// Supplier-visible revisions are based on successful sends, never generated PDF count.
export const getPurchaseOrderEmailRevisionNumber = (_pdfs = [], revisionNumber = 1) =>
  Math.max(1, Number(revisionNumber) || 1);

export const buildPurchaseOrderSupplierEmailSubject = ({
  poNumber,
  poId,
  revisionNumber = 1,
} = {}) => {
  const resolvedPoNumber = poNumber || `PO-${poId || ""}`;
  const number = getPurchaseOrderEmailRevisionNumber([], revisionNumber);
  return `PO ${resolvedPoNumber}${number > 1 ? `-R${number}` : ""} from Elite Promotional Marketing`;
};
